<template>
  <modal
    id="searchDealer"
    name="searchDealer"
    role="dialog"
    aria-labelledby="dialog-title"
    aria-describedby="dialog-content"
    class="m-full"
    :width="700"
    :height="740"
    :maxHeight="740"
    @before-close="beforeClose"
  >
    <div class="dialog__inner">
      <div class="popup-header">
        <h1 id="dialog-title" tabindex="0">대리점검색</h1>
        <button
          type="button"
          class="btn_popup_close"
          data-dismiss="modal"
          title="팝업닫기"
          @click="closeDialog"
        >
          <span>팝업 닫기</span>
        </button>
      </div>

      <div id="dialog-content" class="dialog__content">
        
        
        
        <div class="section">
          <div class="section-body">
            <div class="field-control-sub">
              <div
                id="radio_searchCondition"
                class="input-container input-horizontal"
              >
                <input
                  id="selection-selrId"
                  v-model="searchCondition"
                  type="radio"
                  name="selrId"
                  value="Id"
                  class="input-checkbox input-text"
                  title="검색 조건 선택"
                />
                <label for="selection-selrId" class="input-label">
                  아이디로 검색
                </label>
              </div>
              <div
                id="radio_searchCondition"
                class="input-container input-horizontal"
              >
                <input
                  id="selection-userNm"
                  v-model="searchCondition"
                  type="radio"
                  name="userNm"
                  value="Name"
                  class="input-checkbox input-text"
                  title="검색 조건 선택"
                />
                <label for="selection-userNm" class="input-label"
                  >이름으로 검색</label
                >
              </div>

              <div
                      id="radio_searchCondition"
                      class="input-container input-horizontal"
              >
                <input
                        id="selection-selrCd"
                        v-model="searchCondition"
                        type="radio"
                        name="selrCd"
                        value="Code"
                        class="input-checkbox input-text"
                        title="검색 조건 선택"
                />
                <label for="selection-selrCd" class="input-label"
                >대리점코드로 검색</label
                >
              </div>
            </div>
            <div>
              <div class="field-control-sub">
                <div class="input-wrap">
                  <input
                    v-model="searchParam"
                    type="text"
                    @input="onlyText"
                    name="searchParam"
                    class="input-text input-font input-width-xlarge"
                    placeholder="ID 또는 이름 입력"
                    title="ID 또는 이름 입력"
                  />
                  <button @click="searchDealer" type="button">검색</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-header blind">
            <h3>검색결과 목록</h3>
          </div>
          <div class="section-body">
            <!---검색결과가 없을 경우 노출--->
            <div v-if="dealerList.length === 0">
              <p class="list-summary no-result">
                검색결과가 존재하지 않습니다.
              </p>
            </div>
            <div v-if="dealerList.length !== 0">
              <p class="list-summary">
                검색결과 총
                <span class="primary-text">{{ dealerList.length }}</span> 건
                입니다.
              </p>
              <ul class="list-block-type" tabindex="-1">
                <li
                  v-for="(dealer, index) in displayedDealerList"
                  v-bind:key="index"
                >
                  <a
                    @click="selectDealer(dealer)"
                    title="유치대리점 선택"
                  >
                    <p class="post-number primary-text" title="ID">
                      {{ dealer.spare1 }} / {{ dealer.spare2 }}
                      
                    </p>
                    <p class="list-sub-text">
                      <span class="list-sub-badge">대리점</span>
                      {{ dealer.selrId }}
                    </p>
                    <p class="list-sub-text">
                      <span class="list-sub-badge">조직</span>
                      {{ dealer.rmk }}
                    </p>
                  </a>
                </li>
              </ul>
              <ul class="paging">
                <li>
                  <a
                    @click="pagePrev"
                    v-if="Math.floor((page - 1) / maxPage) !== 0"
                    class="paging-prev"
                    title="이전목록"
                  ></a>
                </li>
                <li
                  v-for="pageNumber in displayedPages"
                  v-bind:key="pageNumber"
                >
                  <a
                    @click="page = pageNumber"
                    title="페이지 번호"
                    :class="{ current: page === pageNumber }"
                    >{{ pageNumber }}</a
                  >
                </li>
                <li>
                  <a
                    @click="pageNext"
                    v-if="
                      Math.floor((page - 1) / maxPage) !==
                        Math.floor((pages.length - 1) / maxPage)
                    "
                    class="paging-next"
                    title="다음목록"
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-body">
            <div class="field-group">
              <div class="field-label">
                <label for="find-dealer-basic">선택 유치대리점</label>
              </div>
              <div class="field-control">
                <div class="field-control-sub">
                  <input
                    v-model="dealerInfo"
                    id="find-dealerInfo-basic"
                    type="text"
                    ref="ref_selectedDealer"
                    class="input-text-disabled input-font wfull"
                    readonly
                    title="검색결과에서 선택한 유치대리점"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- add_20201021_posCd -->
        <!--
        <div class="section">
          <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <label for="">POS명</label>
            </dt>
            <dd class="field-control">
              <select class="input-width-large" v-model="posCode">
                <option value="">선택하세요</option>
                <option
                  v-for="item in posList"
                  :value="item.posCd"
                  :key="item.posCd"
                  >[{{ item.posCd }}]{{ item.posNm }}
                </option>
              </select>
            </dd>
          </dl>
          </div>
        </div>
        -->
        <div class="section">
          <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <label for="">POS코드</label>
            </dt>
            <dd class="field-control">
                <div class="field-control-sub">
                  <input
                    v-model="posCode"
                    id="posCode"
                    type="text"
                    ref="ref_selectedDealer"
                    class="input-text input-font input-width-xlarge"
                    title="POS코드 입력"
                  />
                </div>                
            </dd>
          </dl>
          </div>
        </div>

      </div>
      <div class="dialog__footer">
        <button @click="closeDialog" type="button" class="normal-button">
          취소
        </button>
        <button @click="submit" type="button" class="primary-button"
        ref="ref_submit">
          확인
        </button>
      </div>
    </div>
    <v-dialog />
  </modal>
</template>

<script>
/**getPosList 추가 (add_20201021_posCd)*/
import { getDealerList ,getPosList } from '@/api/onsaleHome'

export default {
  name: 'SearchDealerPopup',
  data() {
    return {
      searchCondition:'Id',

      dealerInfo:'',
      dealer:{
        oRes:'',
        oMsg:'',
        selrId:'',
        selrTyp:'',
        tmpAplyTyp:'',
        csalesCd:'',
        rmk:'',
        selTyp:'',
        selPathCd:'',
        selChnlTyp:'',
        zipCd:'',
        allAddr:'',
        telNo:'',
        email:'',
        dlrCd:'',
        dlrGrpCd:'',
        spare1:'',//ID
        spare2:'',//name
        _rowStatus:'',
        posCd:'',  //대리점 소속 pos code (add_20201021_posCd)
      },
      searchParam: '',
      dealerList: [],
      page: 1,
      perPage: 5,
      maxPage: 5,
      pages: [],

      /** 대리점 소속 pos code (add_20201021_posCd) */
      pos:{
        posCd:'',
        posNm:'',
        posDesc:'',
      },
      posList: [],
      posCode:''
    }
  },
  props: {
    close: Function
  },

  watch: {
    dealerList() {
      this.setPages()
    }
  },

  computed: {
    displayedDealerList() {
      return this.paginate(this.dealerList)
    },
    displayedPages() {
      let page = this.page - 1
      let pageIndex = Math.floor(page / this.maxPage)

      return this.pages.slice(
        pageIndex * this.maxPage,
        (pageIndex + 1) * this.maxPage
      )
    }
  },
  mounted() {
    this.getSelrId()
  },

  created() {
    // document.documentElement.style.overflow = 'hidden'
  },

  methods: {
    getSelrId(){
      if(!this.$route.query.selrId) return
      this.searchParam = this.$route.query.selrId
      this.searchDealer()
    },
    /** 
     * Function    : onlyText
     * Description : input값 텍스트 체크
     **/
    onlyText(e) {
      if(e.target.name === 'searchParam') this.searchParam = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
    },
    
    /** 
     * Function    : searchDealer
     * Description : 판매점 리스트 조회
     **/
    searchDealer() {
      
      if(this.searchCondition === 'Id'){
        getDealerList(this.searchParam,'1')
          .then(res => {
            this.dealerList = res.data.dsOutput
          })
          .catch(e => {
            //console.error(e)
          })
      }
      else if(this.searchCondition === 'Name'){
        getDealerList(this.searchParam,'2')
          .then(res => {
            this.dealerList = res.data.dsOutput
          })
          .catch(e => {
            //console.error(e)
          })
      }
      else{
        getDealerList(this.searchParam,'3')
          .then(res => {
            this.dealerList = res.data.dsOutput
          })
          .catch(e => {
            //console.error(e)
          })
      }
    },

    /** 
     * Function    : setPages
     * Description : 전체 페이지수 설정
     **/
    setPages() {
      this.pages = []
      let numberOfPages = Math.ceil(this.dealerList.length / this.perPage)
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },

    /** 
     * Function    : paginate
     * Description : 페이지 번호
     **/
    paginate(list) {
      let page = this.page
      let perPage = this.perPage
      let from = page * perPage - perPage
      let to = page * perPage
      return list.slice(from, to)
    },

    /** 
     * Function    : pagePrev
     * Description : 페이징 이전 페이지로 이동
     **/
    pagePrev() {
      let page = this.page - 1
      let pageIndex = Math.floor(page / this.maxPage)
      this.page = (pageIndex - 1) * this.maxPage + this.maxPage
      return this.page
    },

    /** 
     * Function    : pageNext
     * Description : 페이징 이후 페이지로 이동
     **/
    pageNext() {
      let page = this.page - 1
      let pageIndex = Math.floor(page / this.maxPage)
      this.page = (pageIndex + 1) * this.maxPage + 1
      return this.page
    },

    /** 
     * Function    : closeDialog
     * Description : Dialog 닫기
     **/
    closeDialog() {
      // document.documentElement.style.overflow = 'auto'
      this.$modal.hide('searchDealer')
    },

    /** 
     * Function    : beforeClose
     * Description : Dialog 닫아질때, 값 초기화
     **/
    beforeClose() {
      // document.documentElement.style.overflow = 'auto'
      this.searchParam = ''
      this.dealerList = []
      this.page = 1
      this.pages = []
      this.dealer = {}
    },
    /** 
     * Function    : searchPos
     * Description : Pos 리스트 조회
     **/
    searchPos(selrId) {
      getPosList('1',selrId)
        .then(res => {
          this.posList = res.data
        })
        .catch(e => {
          //console.error(e)
        })
    },
    /** 
     * Function    : checkPos
     * Description : Pos data check 
     **/
    checkPos(posCd) {
      let result_pos = false
      for (let i = 0; i < this.posList.length; i++) {
        if (posCd === this.posList[i].posCd){
          result_pos = true
          break
        }
      }
      return result_pos
        
    },    
    /** 
     * Function    : selectDealer
     * Description : 판매점 선택 시 확인 버튼 focus
     **/
    selectDealer(dealer) {
      this.dealerInfo = dealer.rmk + "(" + dealer.selrId + "/" + dealer.spare1 + ")"
      this.dealer.selrId = dealer.selrId
      this.dealer.selrTyp = dealer.selrTyp
      this.dealer.tmpAplyTyp = dealer.tmpAplyTyp
      this.dealer.csalesCd = dealer.csalesCd
      this.dealer.rmk = dealer.rmk
      this.dealer.selTyp = dealer.selTyp
      this.dealer.selPathCd = dealer.selPathCd
      this.dealer.selChnlTyp = dealer.selChnlTyp
      this.dealer.zipCd = dealer.zipCd
      this.dealer.allAddr = dealer.allAddr
      this.dealer.telNo = dealer.telNo
      this.dealer.email = dealer.email
      this.dealer.dlrCd = dealer.dlrCd
      this.dealer.dlrGrpCd = dealer.dlrGrpCd
      this.dealer.spare1 = dealer.spare1
      this.dealer.spare2 = dealer.spare2
      this.$refs.ref_selectedDealer.focus()

      /** 대리점에 속한 pos 정보 load (add_20201021_posCd)*/
      this.searchPos(dealer.dlrCd) 
    },

    /** 
     * Function    : validation
     * Description : 필수값 validation
     **/
    validation() {
      //TODO 수정 필요 - (미입력-->미선택)
      let title = '온라인 가입신청 안내'
      if (!this.dealerInfo || this.dealer.selrId === '' || typeof this.dealer.selrId === 'undefined') {
        this.openAlert(title, '유치대리점을 선택해주세요.')
        return false
      }

      /** 선택한 pos정보를 main으로 전달할 dealer정보에 set (add_20201021_posCd) */
      if(this.posCode === '' || typeof this.posCode === 'undefined'){
        this.openAlert(title, 'POS코드를 입력해주세요.')
        return false
      }
 
      /** 대리점에 속한 pos 정보 check (add_20201021_posCd)*/
      /** 대리점에 속한 pos 정보가 있으면 true */
      if (!this.checkPos(this.posCode) ) {
        this.openAlert(title, 'POS코드를 정확히 입력해 주세요.')
        return false
      }else{
        this.dealer.posCd = this.posCode
      } 
      return true
    },

    /** 
     * Function    : submit
     * Description : 확인 클릭 시 이벤트 함수
     **/
    submit() {
      if (!this.validation()) return
      // 팝업에서 데이터 넘겨주는 처리
      this.$emit('close', {
        id: 'ok',
        ok: this.dealer,
      })
      this.closeDialog()
    },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button'
          }
        ]
      })
    }
  }
}
</script>

<style scoped>

</style>
